import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LoanStatus = Loadable(lazy(() => import("./LoanStatus")));

const loanstatusRoute = [{ path: "/loan-status", element: <LoanStatus /> }];
export default loanstatusRoute;
